export default {
    label_task:{
        en:"Analysis Report",
        bn:'Variety Report'
    },

    label_market_size_location_total:{
        en:"Location Total Market Size",
        bn:"Crop"
    },
    label_market_size_total:{
        en:"Total Market Size",
        bn:"Crop"
    },
    label_market_size_arm:{
        en:"Arm Market Size",
        bn:"Crop"
    },
    label_market_size_arm_percentage:{
        en:"Arm Market Size Percentage",
        bn:"Crop"
    },
    label_market_size_competitor:{
        en:"Competitor Market Size",
        bn:"Variety"
    },
    label_market_size_competitor_percentage:{
        en:"Competitor Market Size Percentage",
        bn:"Variety"
    },
    label_upazila_market_size:{
        en:"Upazila Market Size",
        bn:"Crop"
    },
    label_price_approximate:{
        en:"Approximate Price",
        bn:"Crop"
    },
    label_sowing_periods:{
        en:"Sowing Periods",
        bn:"Crop"
    },

    label_type_competitor_market_size_total:{
        en:"competitor Market Size total",
        bn:"Crop"
    },
    label_variety:{
        en:"Variety",
        bn:"Variety"
    },
    label_competitor_variety:{
        en:"Competitor Variety",
        bn:"Variety"
    },
    label_competitor_variety_market_size:{
        en:"Competitor Variety Market Size",
        bn:"Variety"
    },
    label_competitor_variety_sales_reason:{
        en:"Competitor Variety Sales Reason",
        bn:"Variety"
    },
    label_principal_id:{
        en:"Principal",
        bn:"Principal"
    },
    label_principal_name:{
        en:"Principal",
        bn:"Principal"
    },
    label_competitor_id:{
        en:"Competitor",
        bn:"Competitor"
    },
    label_competitor_name:{
        en:"Competitor",
        bn:"Competitor"
    },
}